export interface IGuide {
  tutorialId: string
  nameId: string
  completedDate: string
}

export enum GuideTypeEnum {
  boardAndCommittees,
  insurance,
  invoiceDetails,
  invoiceList,
  subleaseDetails,
  subleaseList,
  unitDetails,
  unitsList,
  email,
  sms,
  noticelist,
  managenotice,
  inboxSettings,
  contacts,
  boardMeetingList,
  boardMeetingCaseList,
  createMeeting,
  meetingDetails,
  completeMeeting,
  messages,
}
